import ForecastItem from "./forecast-item";

const ForecastWidget: React.FC<{ title: string; data: types.ForecastInfo }> = ({
  title,
  data,
}) => {
  return (
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2  flex  gap-4 ">
      {data.forecast.map((item, index) => (
        <ForecastItem key={`${item.date}-${index}`} item={item} />
      ))}
    </div>
  );
};
export default ForecastWidget;
